import { SKILLS } from "../../lib/data";

export const Skills = () => {
  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="hairline-b border-b"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-28">
        <div className="grid grid-cols-12 gap-6 mb-12 md:mb-16">
          <div className="col-span-12 md:col-span-5">
            <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
              07 — What I Bring
            </div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-[0.95]">
              Four lanes,<br />one operator.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 self-end">
            <p className="text-base md:text-lg leading-relaxed text-[var(--muted)] max-w-prose">
              The capability stack — built across business, strategy, execution
              and leadership.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 hairline border-l border-t">
          {SKILLS.map((s, i) => (
            <div
              key={s.cluster}
              data-testid={`skill-cluster-${i}`}
              className="hairline border-r border-b p-6 md:p-8 reveal"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-6">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="text-2xl md:text-3xl font-bold tracking-tight mb-6">
                {s.cluster}
              </h3>
              <ul className="space-y-2.5">
                {s.items.map((it) => (
                  <li
                    key={it}
                    className="text-sm md:text-base hairline-b border-b pb-2 text-[var(--ink)]"
                  >
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
